export const removeUndefinedValues = <T>(arr: (T | undefined)[]): T[] => {
  return arr.filter((i): i is T => i !== undefined)
}
